import { BRIEF_LIST_QUERY_KEY } from "@entities/brief/lib/constants";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { IBrief } from "@shared/lib/types/brief";
import { QueryClient } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { BriefService } from "../services/brief.service";

export const getBriefByIdQueryKey = (briefId: string) => [
  ...BRIEF_LIST_QUERY_KEY,
  briefId,
];

export const setBriefByIdQueryData = (
  queryClient: QueryClient,
  briefId: string,
  response: BackednResponse<IBrief>
) => {
  queryClient.setQueryData(getBriefByIdQueryKey(briefId), response);
};

export function useGetBrIefById(briefId: string) {
  const {
    data: brief,
    isLoading,
    isError,
    error,
    isFetching,
    refetch,
  } = useQuery({
    queryFn: () => BriefService.getBriefById(briefId),
    queryKey: getBriefByIdQueryKey(briefId),
    enabled: !!briefId,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    brief: brief?.data,
    isFetching: isLoading,
    isError,
    isFetchingBrief: isFetching,
    refetch,
  };
}
